import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

/**
 * @description Render memoized featured products cart modal component
 * @param {Object} props
 * @returns {JSX.Element} Memoized featured products cart modal component
 */
export const FeaturedProducts = memo(function MemoizedFeaturedProducts(props) {
  const { products } = props;

  return (
    <div className="mt-12">
      <p className="mb-6  text-center text-base font-normal tracking-widest text-black md:text-left">
        FEATURED PRODUCTS
      </p>
      <div className="flex flex-col justify-between gap-4 sm:flex-row">
        {products && Array.isArray(products) && products?.length > 0
          ? products.map((item, index) => {
              let minPrice = -1;
              let startsAt = '';
              item?.custom_fields?.forEach((item) => {
                if (item.name.toLowerCase().includes('min')) {
                  minPrice = item.value;
                }
                if (item.name.toLowerCase().includes('start')) {
                  startsAt = item.value;
                }
              });
              return (
                <div key={index} className="w-full max-w-full sm:w-80">
                  <div className="flex flex-row items-center gap-2">
                    <img
                      className="h-24 w-24 sm:h-14 sm:w-14 md:h-24 md:w-24"
                      src={item.images?.[0]?.url_standard}
                      alt={item.images?.[0]?.description}
                      loading="lazy"
                    />
                    <div className="flex h-full flex-1 flex-col justify-between gap-4 self-start">
                      {typeof item.name === 'string' && item.name.length > 0 ? (
                        <p className="m-0 text-sm font-medium text-black md:text-xl">{item.name}</p>
                      ) : null}
                      {/*
											{item.options && Array.isArray(item.options) && item.options?.length > 0
												? item.options.map((option_item, index) => (
													<p key={index} className="m-0 text-xs font-normal text-gray-500 md:text-sm">
															{option_item.display_name}: {option_item.option_values?.[1]?.label || ""}
														</p>
												  ))
												: null} */}

                      {typeof item.calculated_price === 'number' && item.calculated_price != 0 ? (
                        <p className="m-0 text-sm font-normal text-black md:text-base">
                          ${item.calculated_price.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                        </p>
                      ) : minPrice != -1 ? (
                        <p className="m-0 text-sm font-normal text-black md:text-base">
                          ${minPrice.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                        </p>
                      ) : startsAt != '' ? (
                        <p className="m-0 text-sm font-normal text-black md:text-base">{startsAt}</p>
                      ) : null}
                    </div>
                  </div>

                  <div className="mt-3">
                    <Link to={item?.custom_url?.url || '#'}>
                      <button className="w-full border border-black py-3 text-sm text-black">View Now</button>
                    </Link>
                  </div>
                </div>
              );
            })
          : null}
      </div>
    </div>
  );
});

FeaturedProducts.propTypes = {
  products: PropTypes.array
};
